exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.fixed_header[data-v-0d2aaabe] {\n    position: fixed;\n    top: 0;\n    z-index: 111111111;\n    background: white;\n    right: 0;\n    left: 300px;\n}\n", ""]);

// exports
